module.exports = __webpack_public_path__ + "static/media/schoppen.55b45177.svg";